import * as React from 'react';
import { styled } from '@mui/material/styles';
import Divider, { dividerClasses } from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MuiMenuItem from '@mui/material/MenuItem';
import { paperClasses } from '@mui/material/Paper';
import { listClasses } from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon, { listItemIconClasses } from '@mui/material/ListItemIcon';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import MenuButton from './MenuButton';
import { User } from '../types/Types';
import { useContext, useState } from 'react'; // #POW-24
import AuthContext from '../context/AuthContext';
import DialogUserProfile from './dialogs/DialogUserProfile'; // #POW-24
import { useTranslation } from "react-i18next"; // #POW-29

const MenuItem = styled(MuiMenuItem)({
  margin: '2px 0',
});

export default function UserOptionsMenu({ user }: { user: User }) {
  const { t } = useTranslation(); // #POW-29
  const auth = useContext(AuthContext)

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [openDialogUserProfile, setOpenDialogUserProfile] = useState(false); // #POW-24
  
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    auth.onLogout();
    setAnchorEl(null);
  };

  // #POW-24
  const handleClickOpenDialogUserProfile = () => {
    setOpenDialogUserProfile(true);
  };
  // #POW-24
  const handleCloseDialogUserProfile = () => {
    setOpenDialogUserProfile(false);
  };

  return (
    <>
      <React.Fragment>
        <MenuButton
          aria-label="Open menu"
          onClick={handleClick}
          sx={{ borderColor: 'transparent' }}
        >
          <MoreVertRoundedIcon />
        </MenuButton>
        <Menu
          anchorEl={anchorEl}
          id="menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          sx={{
            [`& .${listClasses.root}`]: {
              padding: '4px',
            },
            [`& .${paperClasses.root}`]: {
              padding: 0,
            },
            [`& .${dividerClasses.root}`]: {
              margin: '4px -4px',
            },
          }}
        >
          {/*
        <MenuItem onClick={handleClose}>Profile</MenuItem>
        <MenuItem onClick={handleClose}>My account</MenuItem>
        <Divider />
        <MenuItem onClick={handleClose}>Add another account</MenuItem>
        <MenuItem onClick={handleClose}>Settings</MenuItem>
        <Divider />
        */}
          <MenuItem onClick={handleClickOpenDialogUserProfile}>{t('menu.profile')}</MenuItem>
          <Divider />
          <MenuItem
            onClick={handleLogoutClick}
            sx={{
              [`& .${listItemIconClasses.root}`]: {
                ml: 'auto',
                minWidth: 0,
              },
            }}
          >
            <ListItemText>{t('menu.logout')}</ListItemText>
            <ListItemIcon>
              <LogoutRoundedIcon fontSize="small" />
            </ListItemIcon>
          </MenuItem>
        </Menu>
      </React.Fragment>
      <DialogUserProfile open={openDialogUserProfile} onClose={handleCloseDialogUserProfile} user={user} />
    </>
  );
}
